let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f7W2A")).then(() => parcelRequire('iUxNS'));